import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { tryToFetchSingleSuppliers } from '../../../store/brokers/admin/suppliers/SuppliersSlice';
import Loading from '../../../shared/Loading';
import WhiteContainer from '../../../shared/white-container';


const SupplierDetails = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const supplier = useAppSelector((state) => state?.suppliers?.supplier);
    const supplierLoading = useAppSelector((state) => state?.suppliers?.supplierIsLoading);

    useEffect(() => {
        if (id) {
            dispatch(tryToFetchSingleSuppliers(id));
        }
    }, []);

    const onGoBack = () => {
        navigate('/suppliers?type=suppliers')
    }

    return (
        <div>
            <div className={'flex flex-row items-center justify-between'}>
                <div className='flex flex-row items-center'>
                    <div onClick={onGoBack} className='md:-ml-2 xl:-ml-8 md:mr-2 xl:mr-10'>
                        <img src={'/assets/shared/go-back.svg'} className={'w-[18px] object-contain cursor-pointer'} />
                    </div>
                    <p className='page-title'>Supplier Details</p>
                </div>
            </div>
            {supplierLoading ?
                <div className='my-3 flex flex-row justify-center items-center'>
                    <Loading />
                </div>
                : <div>
                    <WhiteContainer type={'rounded'}>
                        <div className='grid grid-cols-1 lg:grid-cols-2 gap-1'>
                            <div>
                                <p className='mb-1'><b>Name:</b> {supplier?.name}</p>
                                <p className='mb-1'><b>Username:</b> {supplier?.username}</p>
                                <p className='mb-1'><b>Email:</b> {supplier?.email}</p>
                                <p className='mb-1'><b>Is Enabled:</b> {supplier?.enabled ? 'Yes' : 'No'}</p>
                            </div>
                            <div>
                                <p className='mb-1'><b>Country:</b> {supplier?.country}</p>
                            </div>
                        </div>
                    </WhiteContainer>
                </div>
            }
        </div>
    )
}

export default SupplierDetails;